var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartHomeControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2C5.89543 2 5 2.89543 5 4V20C5 21.1046 5.89543 22 7 22H17C18.1046 22 19 21.1046 19 20V4C19 2.89543 18.1046 2 17 2H7ZM10 3.75H14C14.4142 3.75 14.75 4.08579 14.75 4.5C14.75 4.91421 14.4142 5.25 14 5.25H10C9.58579 5.25 9.25 4.91421 9.25 4.5C9.25 4.08579 9.58579 3.75 10 3.75ZM13.5 18.5C13.5 19.3284 12.8284 20 12 20C11.1716 20 10.5 19.3284 10.5 18.5C10.5 17.6716 11.1716 17 12 17C12.8284 17 13.5 17.6716 13.5 18.5ZM8 9.46736C8 9.26386 8.11086 9.07493 8.29286 8.96828L11.355 7.17386C11.7505 6.94205 12.2495 6.94205 12.645 7.17386L15.7071 8.96828C15.8891 9.07493 16 9.26386 16 9.46736V14.414C16 14.7376 15.7245 15 15.3846 15H13.5385V12.949C13.5385 12.1399 12.8497 11.4839 12 11.4839C11.1503 11.4839 10.4615 12.1399 10.4615 12.949V15H8.61539C8.27552 15 8 14.7376 8 14.414V9.46736Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartHomeControl);
export default __webpack_public_path__ + "static/media/smart-home-control.8c8c9ca203c141e59b68eebe1c925bce.svg";
export { ForwardRef as ReactComponent };